<template>
    <div class="modal">
        <div class="modal__inner" :style="bodyStyle">
            <div class="modal__close  modal__close--primary" v-if="full">
                <div class="modal__close__inner  modal__close__inner--flip">
                    <slot v-if="useWiggleBg" name="wiggle" />

                    <div class="modal__close__content">
                        <div @click="close()" :class="[closeClass]">
                            <i class="fal fa-times text-4xl md:text-5xl cursor-pointer"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal__content" :class="{'modal__content--secondary': typeof secondary !== false}" v-if="!full" v-on-clickaway="close">
                <slot />
            </div>
            <div class="modal__content" :class="{'modal__content--secondary': typeof secondary !== false}" v-else>
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
    name: 'ModalComponent',
    mixins: [clickaway],

    props: {
        full: {
            required: false,
            default: false
        },
        secondary: {
            required: false,
            default: false
        },
        useWiggleBg: {
            required: false,
            default: true
        },
        bodyStyle: {
            required: false,
            default: ''
        },
        closeClass: {
            required: false,
            default: ''
        }
    },

    created() {
        document.addEventListener('keydown', this.handleEscape)
        document.body.classList.add('overflow-hidden')

        const modalBg = document.createElement('div')
        modalBg.classList = 'fixed pin bg-80 z-20 opacity-75'

        this.modalBg = modalBg

        document.body.appendChild(this.modalBg)

        this.$nextTick(() => {
            setTimeout(() => {
                if (typeof window.rTapNotifyDOMChange === "function") {
                    window.rTapNotifyDOMChange(document.body);
                }
            }, 500);
        });
    },

    destroyed() {
        document.removeEventListener('keydown', this.handleEscape)
        document.body.classList.remove('overflow-hidden')
        document.body.removeChild(this.modalBg)
    },

    data: () => ({ modalBg: null }),

    methods: {
        handleEscape(e) {
            e.stopPropagation()

            if (e.keyCode == 27) {
                this.close()
            }
        },

        close() {
            this.$emit('close')
        },
    },
}
</script>



// WEBPACK FOOTER //
// Modal.vue?3e7fd3e4